import { createCRUDHooks } from "@/lib/hooks-factory";
import { productCategoriesApi } from "@/api/products/product-categories-api";
import type {
  ProductCategory,
  ProductCategoryCreate,
  ProductCategoryUpdate,
} from "@/types/products/api-types/product-category-types";
import type { CRUDApiParams } from "@/lib/api-factory";

interface ProductCategorySearchParams extends CRUDApiParams {
  page?: number;
  size?: number;
  name?: string;
  active_only?: boolean;
}

const hooks = createCRUDHooks<ProductCategory, ProductCategoryCreate, ProductCategoryUpdate, ProductCategorySearchParams>({
  queryKey: "product-categories",
  api: productCategoriesApi,
  invalidateKeys: ["products"],
  mapToOption: (category: ProductCategory) => ({
    value: category.id,
    label: category.name,
  }),
  getLoadParams: (search: string, page: number, size: number): ProductCategorySearchParams => ({
    page,
    size,
    name: search || undefined,
    active_only: true,
  }),
});

export const useGetProductCategoriesPaginated = hooks.useGetPaginated;
export const useCreateProductCategory = hooks.useCreate;
export const useUpdateProductCategory = hooks.useUpdate;
export const useDeleteProductCategory = hooks.useDelete;
export const useProductCategoryLoadOptions = hooks.useLoadOptions!;
